import { useEffect, useState } from 'react'
import FormPage from '../../../../Components/Form/Page/FormPage'
import AnimatedHeading from '../../../../Components/UI/AnimatedHeading'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import getAdjacentSteps from '../../../../Logic/Form/Authorization/getAdjacentSteps'
import { LocationAttributes } from '../../../../Types/Location'
import BaseLocationInput from '../Base'
import InputView from '../../InputView'
import { getDefaultLocationAttrs, LocationAttributesWithoutRadius } from '../Base/LocationInput'
import GeocodeErrorAlert from './GeocodeError'
import './LocationInput.less'
import './LocationInputAnimation.less'
import { getDefaultRadius } from '../../../../Utilities/Location'
import CombinedSlider from '../Base/CombinedSlider/CombinedSlider'

const LocationInput: InputView = ({ path }) => {
  const { brief, dispatchBrief, loading, geocodeError } = useBriefContext()
  const [locationAttributes, setLocationAttributes] = useState<
    LocationAttributesWithoutRadius | undefined
  >(getDefaultLocationAttrs(brief))
  const [pageClassName, setPageClassName] = useState('')
  const [radius, setRadius] = useState<LocationAttributes['radius']>(
    brief.radius ?? getDefaultRadius(brief)
  )
  useEffect(() => {
    if (loading || locationAttributes === undefined) return

    setPageClassName('delay-map-animations')
  }, [loading])

  const { isStepComplete } = getAdjacentSteps(path, brief)

  const allLocationAttrs = { radius, ...(locationAttributes && locationAttributes) }
  const isLeadFeedReady = locationAttributes?.leadFeedCity !== undefined
  const hasCompleteLocation = isStepComplete(allLocationAttrs)
  const onContinue = () => dispatchBrief({ updateAttributes: allLocationAttrs })

  return (
    <FormPage
      path={path}
      metaTitle='Location - HeadBox'
      header={<AnimatedHeading className='mb-6'>What location works best?</AnimatedHeading>}
      alert={geocodeError && <GeocodeErrorAlert />}
      onContinue={onContinue}
      canContinue={isLeadFeedReady || hasCompleteLocation}
      className={`location-input leadfeed ${pageClassName}`}>
      <BaseLocationInput
        radius={radius}
        locationAttributes={locationAttributes}
        setLocationAttributes={setLocationAttributes}
        setRadius={setRadius}>
        <CombinedSlider
          country={locationAttributes?.country}
          radius={radius}
          setRadius={setRadius}
          show={!!locationAttributes?.location}
          title={'You will mainly hear from venues inside the circle you choose:'}
        />
      </BaseLocationInput>
    </FormPage>
  )
}

export default LocationInput
